// Skanerdən satışa keçid (KT-108): sessionStorage açarı — mal satış ekranında bir dəfə səbətə düşür.
export const SALE_PENDING_KEY = 'kassa.sale.pending';
